import React from "react";
import { GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { ensureVideoFileRecordDetails, FileRecordDetails } from "../FileRecordDetails";

interface VideoFileRecordTechnicalViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const VideoFileRecordTechnicalView = ({ fileRecordDetails }: VideoFileRecordTechnicalViewProps): JSX.Element => {
    ensureVideoFileRecordDetails(fileRecordDetails);

    return (
        <GridRow>
            <GridColumn sm={3}>
                <LabeledText label="Duration" value={fileRecordDetails.technical?.duration} testId="Duration" />
                <LabeledText
                    label="Encoding"
                    value={fileRecordDetails.technical?.encoding ? "Prores" : "Not prores"}
                    testId="Encoding"
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Bitrate"
                    value={fileRecordDetails.technical?.videoBitRate}
                    testId="bit-rate-field"
                />

                <LabeledText
                    label="Resolution"
                    value={fileRecordDetails.technical?.resolution}
                    testId="resolution-field"
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Aspect ratio"
                    value={fileRecordDetails.technical?.aspectRatio?.name ?? "-"}
                    testId="aspect-ratio-field"
                />
                <LabeledText
                    label="Framerate"
                    value={fileRecordDetails.technical?.framerate}
                    testId="framerate-field"
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Aspect type"
                    value={fileRecordDetails.technical?.aspectType?.name ?? "-"}
                    testId="aspect-type-field"
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Standard"
                    value={fileRecordDetails.technical?.standard?.name}
                    testId="standard-field"
                />
            </GridColumn>
        </GridRow>
    );
};
